import "./NewYearDecoration.css";

const NewYearDecoration = () => {
    return (
        <>
            {/* Top Garland with White Background */}
            <div className="garland-container">
                <div className="top-decoration">
                    {[...Array(10)].map((_, i) => (
                        <img
                            key={i}
                            src="/240_F_636218795_q2udOclB912u63oS34pgV5Is1uVUwu9u-removebg-preview.png"
                            alt="Christmas Garland"
                        />
                    ))}

                    {/* New Year Lights */}
                    <div className="garland-lights">
                        {[...Array(20)].map((_, i) => (
                            <div
                                key={i}
                                className={`ny-light color-${i % 5}`}
                                style={{
                                    left: `${(i * 5)}%`,
                                    animationDelay: `${i * 0.15}s`
                                }}
                            >
                                <div className="light-glow" />
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Top Right Corner Decoration */}
            <div className="corner-decoration">
                <img
                    src="/png-transparent-ded-moroz-snegurochka-holiday-new-year-others-decor-branch-christmas-decoration-removebg-preview.png"
                    alt="Christmas Decoration"
                />
            </div>

            {/* Snowflakes */}
            <div className="snowflakes" aria-hidden="true">
                {[...Array(15)].map((_, i) => (
                    <div key={i} className="snowflake">❅</div>
                ))}
            </div>
        </>
    );
};

export default NewYearDecoration;
